let SORT = {
  descending: 'desc',
  ascending: 'asc'
};

export
default SORT;


// WEBPACK FOOTER //
// ./app/models/sort.js